import { TFunction } from 'i18next'
import React, { FC, Fragment } from 'react'
import Button from '../../../../components/actions/Button'
import { EventsHook } from '../../hooks/useEvents'
import EventCard from './EventCard'
import NoEvents from './NoEvents'

interface EventListProps {
	eventsHook: EventsHook
	t: TFunction<'pages_saving'>
}

const EventList: FC<EventListProps> = ({ eventsHook, t }) => {
	const { events, isInitialLoading, hasEvents, hasNextPage, fetchNextPage, isFetchingNextPage } =
		eventsHook

	const handleLoadMore = () => {
		if (hasNextPage && !isFetchingNextPage) {
			fetchNextPage()
		}
	}

	if (!isInitialLoading && !hasEvents)
		return (
			<NoEvents eventsHook={eventsHook} t={t}>
				<Button onClick={handleLoadMore} disabled={isFetchingNextPage} className='m-0 mt-4'>
					{isFetchingNextPage ? t('loading') : (t as any)('loadMore')}
				</Button>
			</NoEvents>
		)

	if (isInitialLoading) return null

	return (
		<div className='bg-white dark:bg-[#0d2d30] border border-[#c4c4c4] dark:border-[#144448] rounded-xl p-3'>
			{Object.entries(events).map(([date, eventsList], i, arr) => (
				<Fragment key={date}>
					<div className='flex flex-col justify-center gap-2'>
						<span className='text-md font-semibold text-text-dark dark:text-white'>{date}</span>

						{eventsList.map((event, j) => (
							<EventCard key={j} appliance={event.appliance} saving={event.saving} />
						))}
					</div>

					{i < arr.length - 1 && (
						<hr className='my-4 border-t border-gray-200 dark:border-surface-dark' />
					)}
				</Fragment>
			))}

			{hasEvents && hasNextPage && (
				<Button onClick={handleLoadMore} disabled={isFetchingNextPage} className='m-0 mt-4'>
					{isFetchingNextPage ? t('loading') : (t as any)('loadMore')}
				</Button>
			)}
		</div>
	)
}

export default EventList
